import { atom } from "jotai";

export const showInvalidImageMessageAtom = atom(false);
